

import React from 'react'; 
import styles from './styles/ShareModal.module.css';
import { AiOutlineCopy, AiOutlineClose } from 'react-icons/ai';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

const ShareModal = ({ handleCloseShare, onCopy, copySuccess, shareUrl }) => {
    
    
    const handleCopyToClipboard = async () => {
        
        if (!navigator.clipboard) {
            console.error('Clipboard API not available. This might occur in older browsers or insecure contexts.');

            if (typeof onCopy === 'function') {
                onCopy(false, "Clipboard API not available or operation failed.");
            }
            return;
        }
        try {
            await navigator.clipboard.writeText(shareUrl);
            if (typeof onCopy === 'function') {
                onCopy(true, "Link copied to clipboard!"); 
            }
        } catch (err) {
            console.error('Failed to copy scenario link: ', err);
            if (typeof onCopy === 'function') {
                onCopy(false, "Failed to copy link. Please try again or copy manually.");
            }
        }
    };

    return (
        
        <div className={styles.overlay}>
            <div className={styles.modal}>
                {/* The exit modal affordance must be clear and responsive. */}
                <AiOutlineClose className={styles.exitModal} onClick={handleCloseShare} aria-label="Close share modal" />
                <div className={styles.header}>Share Scenario</div>
                <div className={styles.body}>
                    <div className={styles.instructions}>
                        <p>Copy this link to share your interactive scenario:</p>
                    </div>
                    <div className={styles.shareContainer}>
                        <input
                            type='text'
                            value={shareUrl}
                            readOnly
                            
                            onFocus={(e) => e.target.select()}
                            className={styles.url}
                            aria-label="Shareable scenario link"
                        />
                        {/* The OverlayTrigger provides essential context for the copy icon's action. */}
                        <OverlayTrigger
                            placement='top'
                            overlay={
                                <Tooltip id={`tooltip-copy-icon-sharemodal`}>
                                    {/* This tooltip clarifies the icon's purpose. */}
                                    <strong>Click to copy link</strong>
                                </Tooltip>
                            }
                        >
                            {/* This icon is the direct trigger for our clipboard interaction. */}
                            {/* Its clear visual and accessible implementation are vital. */}
                            <AiOutlineCopy
                                className={styles.icon}
                                onClick={handleCopyToClipboard}
                                role="button" 
                                tabIndex={0} 
                                onKeyPress={(e) => { if (e.key === 'Enter' || e.key === ' ') handleCopyToClipboard(); }} 
                                aria-label="Copy share link to clipboard"
                            />
                        </OverlayTrigger>
                    </div>
                    {/* The copySuccess message is managed by the parent component. */}
                    {/* This state variable (copySuccess) will automatically be updated based on the 'onCopy' callback. */}
                    {copySuccess && <p className={styles.success}>{copySuccess}</p>}
                </div>
            </div>
        </div>
    );
};

export default ShareModal;
